import React, { JSX, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import GoogleIcon from '@mui/icons-material/Google'
import makeStyles from '@mui/styles/makeStyles/makeStyles'
import { Theme } from '@mui/material'

import TabMenu from './Tabs'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

export interface Tab {
  icon: JSX.Element
  name: NetworkType
  label: string
}

interface IProps {
  activeItem?: NetworkType
  tabs: NetworkType[]
  onChangeTab?: (key: NetworkType) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    width: '1.3rem',
    verticalAlign: 'top',
    fill: theme.palette.info.main,
  },
}))

const DashboardOverviewTabs: React.FC<IProps> = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [tabs, setTabs] = useState<Tab[]>([])
  const [activeItem, setActiveItem] = useState<NetworkType>()

  useEffect(() => {
    const createTabs: Tab[] = []
    props.tabs.map((tab: NetworkType) => {
      let icon = <span style={{ paddingRight: '10px' }}><FacebookIcon className={classes.icon} /></span>
      if (tab === NetworkType.Instagram) {
        icon = <span style={{ paddingRight: '10px' }}><InstagramIcon className={classes.icon} /></span>
      }
      if (tab === NetworkType.LinkedIn) {
        icon = <span style={{ paddingRight: '10px' }}><LinkedInIcon className={classes.icon} /></span>
      }
      if (tab === NetworkType.GoogleMyBusiness) {
        icon = <span style={{ paddingRight: '10px' }}><GoogleIcon className={classes.icon} /></span>
      }
      createTabs.push({
        icon: icon,
        name: tab,
        label: t(`dashboard:${tab}`),
      })
    })
    setTabs(createTabs)
    setActiveItem(props.activeItem ? props.activeItem : createTabs[0].name)
  }, [props.tabs],
  )

  useEffect(() => {
    props.activeItem && setActiveItem(props.activeItem)
  }, [props.activeItem],
  )

  return (
    <TabMenu
      tabs={tabs} activeItem={activeItem} onChangeTab={(tab: NetworkType) => {
        props.onChangeTab && props.onChangeTab(tab)
      }}
    />
  )
}
export default DashboardOverviewTabs
